import type { GameModule } from './types'

/** M2 modules stay in the registry for home silhouettes; they have no playable screen. */
export function placeholderGame(
  fields: Pick<GameModule, 'id' | 'titleVi' | 'iconSrc'>,
): GameModule {
  return {
    ...fields,
    playable: false,
    mount(root) {
      root.replaceChildren()
      return () => {
        root.replaceChildren()
      }
    },
  }
}
